module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-section c-section--promotions"
  }, [_c('div', {
    staticClass: "o-container o-container--large"
  }, [_c('header', [_c('h2', [_vm._v("Discover your ikigai in Japan with")]), _vm._v(" "), _c('a', {
    staticClass: "c-promotions-logo",
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Footer Logo');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "c-promotions"
  }, _vm._l((_vm.promotions), function(promo) {
    return _c('li', {
      staticClass: "c-promotions__item"
    }, [_c('div', {
      staticClass: "c-promotions__route"
    }, [_vm._v("\n          " + _vm._s(promo.from) + " "), _c('icon', {
      attrs: {
        "name": "plane",
        "role": "presentation",
        "label": "Plane"
      }
    }), _vm._v(" " + _vm._s(promo.to) + "\n        ")], 1), _vm._v(" "), _c('div', {
      staticClass: "c-promotions__price"
    }, [_vm._v("\n          from "), _c('span', [_vm._v("$" + _vm._s(promo.price)), _c('sup', [_vm._v("*")])])]), _vm._v(" "), _c('a', {
      staticClass: "c-button c-button--secondary c-button--thin",
      attrs: {
        "href": "https://www.airasia.com/au/en/promotion.page?rr=rr1530605&utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.$ga.event('SecretScrolls', 'Click', ("Book Now " + (promo.from) + " " + (promo.to)));
        }
      }
    }, [_vm._v("Book Now")])])
  })), _vm._v(" "), _c('p', {
    staticClass: "c-promotions__conditions"
  }, [_vm._v("*Conditions apply. See airasia.com for details. Processing fees may apply.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4f699a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Promotions.vue
// module id = 69
// module chunks = 0